module.exports = __webpack_public_path__ + "img/Lysa.9e741d7c.png";